import { render } from "./DsForo.vue?vue&type=template&id=4f0f5fb2&scoped=true"
import script from "./DsForo.vue?vue&type=script&lang=js"
export * from "./DsForo.vue?vue&type=script&lang=js"

import "./DsForo.vue?vue&type=style&index=0&id=4f0f5fb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0f5fb2"]])

export default __exports__